// extracted by mini-css-extract-plugin
export var dropdownIcon = "_p1-6";
export var imgContainer = "_p1-3";
export var menuIcon = "_p1-5";
export var pillWrapper = "_p1-2";
export var pillsContainer = "_p1-1";
export var subscriptionCard = "_p1-0";
export var subscriptionLogo = "_p1-4";